module.exports = __webpack_public_path__ + "img/warsztaty-filipiny-2.29341271.jpg";